import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { getPlayerStats } from "@/api/stats";
import { createColumns } from "@/components/stats/PlayerColumns";
import { PlayerTable } from "@/components/stats/PlayerTable";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/ui/Breadcrumb";
import { Skeleton } from "@/components/ui/Skeleton";
import { PlayerStats } from "@/lib/types";

export default function PlayerStatsPage() {
  const [playerStats, setPlayerStats] = useState<PlayerStats[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    setLoading(true);
    const playerStats: PlayerStats[] = await getPlayerStats(
      "TODO Add real token",
    );
    setPlayerStats(playerStats);
    setLoading(false);
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const columns = createColumns({
    handleClick: (p: PlayerStats) => {
      alert(`Clicked ${p.pitchType}`);
    },
  });

  return (
    <>
      <div className="flex items-end">
        <div>
          <h2 className="text-2xl mt-5">Player Stats</h2>
          <Breadcrumb className="hidden md:flex mt-3 my-5">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/dashboard">Dashboard</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/stats/player">Player Stats</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </div>
      <div className="bg-white">
        {loading ? (
          <Skeleton className="w-full h-[200px] rounded" />
        ) : (
          <PlayerTable columns={columns} data={playerStats} />
        )}
      </div>
    </>
  );
}
